// src/AppShell.jsx
import { Toaster } from 'react-hot-toast';
import AppProviders from './contexts/AppProviders';
import MainLayout from './MainLayout'; // Your actual app content

export default function AppShell() {
  return (
    <AppProviders>
      <MainLayout />
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: '#fefce8',
            color: '#36454f',
            fontFamily: 'Georgia, serif',
            fontSize: '0.875rem',
            border: '1px solid #facc15',   
            padding: '10px 14px',
          },
          iconTheme: {
            primary: '#a88905',
            secondary: '#fefce8',
          },
          duration: 3000,
          className: 'shadow-md rounded',
        }}
      />
    </AppProviders>
  );
}